<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Crear" }} Raza</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form v-if="petTypes" @submit.prevent="save">
        <div class="flex flex-col w-full">
          <label for="pet_type_id">Animal</label>
          <custom-select
            id="pet_type_id"
            v-model="form.pet_type_id"
            :options="getPetTypeOptions()"
          />
          <validation-errors
            :errors="errorFor('pet_type_id')"
          ></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="name">Raza</label>
          <input id="name" type="text" v-model="form.name" />
          <validation-errors :errors="errorFor('name')"></validation-errors>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Role Form",

  data() {
    return {
      form: {
        name: "",
        pet_type_id: null,
      },
      loading: false,
      loadingForm: false,
      petTypes: null,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "breeds");

    this.loadPetTypes();
  },

  mixins: [validationErrors],

  methods: {
    async loadPetTypes() {
      this.loading = true;

      try {
        this.petTypes = await api.resources.getPetTypes();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getPetTypeOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.petTypes.forEach((petType) => {
        options.push({
          value: petType.id,
          label: petType.name,
        });
      });

      return options;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.createBreed();
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!this.form.pet_type_id) {
        this.errors["pet_type_id"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createBreed() {
      this.loadingForm = true;

      try {
        const response = await api.breeds.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: 'breedsIndex' });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>